<!--
  @description: 订单列表新增虚拟服务商品--月嫂育儿服务订单
                判断条件为：
                isYSOrder: +order.useRight === 4 && order.level4CategoryId === '10112210'
  @author：      19185247 刘云飞
  @date:         2020-09-29
-->
<template lang="html">
  <YSItem
    v-if="isYSOrder"
    :index="index"
    :order="order"
    :totalPayMoney="totalPayMoney"
    :gotoUserDetail="gotoUserDetail"
    :gotoOrderDetail="gotoOrderDetail"
    :prePayOrder="prePayOrder"
    :endPayOrder="endPayOrder"
  />
  <li v-else>
    <div class="order-title">
      <div class="seller-info" @click="gotoUserDetail(order)">
        <img src="../../assets/images/order/icon-store.png" alt="" />
        <div class="seller-name pf-medium">{{ order.businessName }}</div>
      </div>
      <div class="order-status order-status-lighted">
        {{ orderSynthesisStateDesc }}
      </div>
    </div>
    <div class="order-info">
      <div class="order-info-inner" @click="gotoOrderDetail(order)">
        <div class="rlt">
          <i class="pf-medium icon-reward" v-if="isReward">赠</i>
          <img :src="order.commdtyImage | avatar(250, 150)" />
        </div>

        <div class="info">
          <div class="info-group-top">
            <div class="name-item">
              <div class="name item-cell-left pf-medium">
                {{ order.spuName }}
              </div>
              <div class="price item-cell-right pf-simbold">
                &yen;{{ (order.orderPrice / order.num) | priceNum }}
              </div>
            </div>
            <div class="name-item">
              <div class="skuName">规格：{{ order.skuName }}</div>
              <span class="number">x{{ order.num }}</span>
            </div>
          </div>
          <div class="time" v-if="displayAppontDay">
            下单时间：{{ displayAppontDay }}
          </div>
        </div>
      </div>
      <div class="order-total-pay">
        <p>
          <span v-if="!prePayOrder">总价：&yen;{{ totalOrderPrice }}，</span>
          <span v-if="!prePayOrder && orderDistcountPrice"
            >优惠：&yen;{{ orderDistcountPrice }}，</span
          >
          <span
            class="real-pay"
            v-if="prePayOrder && prePayOrder.preOrderState == 10"
            >待付定金：
            <span class="total-y pf-medium"
              >&yen;{{ prePayOrder.prePayPrice | priceNum }}</span
            >
          </span>

          <span
            class="real-pay"
            v-else-if="endPayOrder && endPayOrder.endOrderState == 10"
            >已付定金：&yen;{{ prePayOrder.prePayPrice | priceNum }}，待付尾款：
            <span class="total-y pf-medium"
              >&yen;{{ endPayOrder.endPayPrice | priceNum }}</span
            >
          </span>
          <!--  待支付 - 应付款，其他都是 - 实付款 -->
          <span v-else class="real-pay"
            >{{ order.orderState == 10 ? '应付款' : '实付款' }}：<span
              class="total-y pf-medium"
              ><template v-if="payScore">{{ payScore.labelValue }}积分</template
              ><template v-else>&yen;{{ totalPayMoney }}</template></span
            >
          </span>
        </p>
      </div>
      <ItemButton :index="index" :order="order" :OpenDel="false" />
    </div>
  </li>
</template>

<script>
import ItemButton from './listItem/button.vue'
import YSItem from './listItem/ys'
import { pushHref, pushNrNs } from '@/plugins/jump'
import {
  isNewAsignedMonthInLaw,
  isRewardType,
  getOrderSynthesisStateDesc
} from '@/business/order'

import dayjs from 'dayjs'
export default {
  components: {
    ItemButton,
    YSItem
  },
  props: {
    order: {
      type: Object,
      default() {
        return {}
      }
    },
    index: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      isYSOrder: isNewAsignedMonthInLaw(this.order),
      // 10.待支付20.待使用30.待评价40.已完成50.已取消
      orderButtonState: 0,
      tabText: ''
    }
  },
  methods: {
    gotoUserDetail(order) {
      // if (order.workerUid) {
      //     this.tabText = document.querySelectorAll('.column-list .active')[0].innerText
      //     location.href = `/v/user/${order.workerUid}`
      // }
    },
    gotoOrderDetail(order) {
      this.tabText = document.querySelectorAll(
        '.column-list .active'
      )[0].innerText
      this.$$loading(true)
      // 使用路由跳转方式，用户在订单详情页打开核销码，返回打开另外一个订单并展示核销码会出现二维码重复的bug，原因不明，恢复href跳转方式
      // this.$router.push(
      //   `/order/${order.orderId}?cmd=share&sharetype=0&isys=${+this.isYSOrder}`,
      // )
      location.href = `/v/order/${
        order.orderId
      }?cmd=share&sharetype=0&isys=${+this.isYSOrder}`
    }
  },
  computed: {
    orderSynthesisStateDesc() {
      return getOrderSynthesisStateDesc(this.order)
    },
    displayAppontDay() {
      // 当前部分订单确认页取消了服务时间，所以存在服务端没有落该字段。现和产品确认，修改为：订单列表页统一展示，订单下单时间
      const { orderTime } = this.order
      return dayjs(orderTime).format('YYYY-MM-DD HH:mm:ss')
    },
    totalOrderPrice() {
      return this.order.orderPrice / 100
    },
    payScore() {
      try {
        const extInfo = JSON.parse(this.order.extInfo)
        return extInfo.find(item => item.labelKey == 'payScore')
      } catch (error) {
        return null
      }
    },
    orderDistcountPrice() {
      return this.order.discountPrice / 100
    },
    totalPayMoney() {
      return this.order.payPrice / 100
    },
    isPayPeriod() {
      // 是否为定金尾款单 0 否 1 是
      return this.order.isPayPeriod && this.order.isPayPeriod == 1
    },
    prePayOrder() {
      if (this.isPayPeriod) {
        const { payPeriodInfo = {} } = this.order || {}
        const { prePayOrder = {} } = payPeriodInfo
        return prePayOrder
      }
      return null
    },
    endPayOrder() {
      if (this.isPayPeriod) {
        const { payPeriodInfo = {} } = this.order || {}
        const { endPayOrder = {} } = payPeriodInfo
        return endPayOrder
      }
      return null
    },
    isReward() {
      return isRewardType(this.order.channelType)
    }
  }
}
</script>
<style lang="scss" scoped src="./orderListItemStyle.scss" />
